import { render, staticRenderFns } from "./classroom_edit.vue?vue&type=template&id=441e5ff2&scoped=true"
import script from "./classroom_edit.vue?vue&type=script&lang=ts"
export * from "./classroom_edit.vue?vue&type=script&lang=ts"
import style0 from "./classroom_edit.vue?vue&type=style&index=0&id=441e5ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441e5ff2",
  null
  
)

export default component.exports